module.exports = __webpack_public_path__ + "img/Add Document (Icon).8d892819.svg";